<p-dialog
  [(visible)]="visible"
  [modal]="true"
  [closable]="true"
  [draggable]="false"
  [resizable]="false"
  [style]="{ width: 'min(1240px, 96vw)' }"
  (onHide)="close()">

  <ng-template pTemplate="header"></ng-template>

  <div class="modal-body">
    <div class="modal-header-content"
         *ngIf="showTunerStep || tunerStepLoading || showConfirm || upgradeSuccess">
      <img src="assets/img/logo-ftcloud-ia.svg" class="modal-header-logo" alt="FT Pilot IA" />
      <span class="modal-header-title">{{ 'proModal.header.line1' | transloco }}</span>
      <span class="modal-header-title">{{ 'proModal.header.line2' | transloco }}</span>
    </div><!-- /modal-header-content -->

    <!-- Loading: verificando tuner -->
    <div *ngIf="tunerStepLoading" class="loading-wrapper">
      <p-progressSpinner styleClass="plan-spinner" strokeWidth="4" />
    </div>

    <!-- Passo de seleção de tuner — OCULTO: goToSubscription() não seta mais showTunerStep=true (esconder sem remover; reativar: descomentar o bloco em goToSubscription). -->
    <div *ngIf="showTunerStep && !tunerStepLoading" class="tuner-step">
      <div class="tuner-step-icon">
        <i class="pi pi-users"></i>
      </div>
      <h3 class="tuner-step-title">{{ 'proModal.tuner.title' | transloco }}</h3>
      <p class="tuner-step-desc">{{ 'proModal.tuner.desc' | transloco }}</p>

      <div class="tuner-step-mode-toggle">
        <button class="toggle-btn" [class.active]="tunerMode === 'list'" (click)="tunerMode = 'list'; selectedTunerId = null">
          {{ 'proModal.tuner.modeList' | transloco }}
        </button>
        <button class="toggle-btn" [class.active]="tunerMode === 'code'" (click)="tunerMode = 'code'; selectedTunerId = null">
          {{ 'proModal.tuner.modeCode' | transloco }}
        </button>
      </div>

      <!-- Lista pública de tuners -->
      <div *ngIf="tunerMode === 'list'" class="tuner-list">
        <div *ngIf="tunerOptions.length === 0" class="tuner-list-empty">
          {{ 'proModal.tuner.noTuners' | transloco }}
        </div>
        <div *ngFor="let tuner of tunerOptions"
             class="tuner-option"
             [class.selected]="selectedTunerId === tuner.userID"
             (click)="selectedTunerId = tuner.userID">
          <div class="tuner-option-icon"><i class="pi pi-user"></i></div>
          <div class="tuner-option-name">{{ tuner.name }}</div>
          <div class="tuner-option-check" *ngIf="selectedTunerId === tuner.userID">
            <i class="pi pi-check-circle"></i>
          </div>
        </div>
      </div>

      <!-- Código de convite -->
      <div *ngIf="tunerMode === 'code'" class="tuner-code-section">
        <div class="tuner-code-input-row">
          <input class="tuner-code-input"
                 [(ngModel)]="tunerInviteInput"
                 placeholder="{{ 'proModal.tuner.codePlaceholder' | transloco }}"
                 (keydown.enter)="validateInviteCode()" />
          <button class="tuner-validate-btn" [disabled]="inviteValidating || !tunerInviteInput.trim()" (click)="validateInviteCode()">
            <i [class]="inviteValidating ? 'pi pi-spin pi-spinner' : 'pi pi-search'"></i>
          </button>
        </div>
        <div *ngIf="inviteError" class="tuner-invite-error">
          <i class="pi pi-exclamation-circle"></i> {{ inviteError }}
        </div>
        <div *ngIf="validatedTuner" class="tuner-option selected">
          <div class="tuner-option-icon"><i class="pi pi-star-fill"></i></div>
          <div class="tuner-option-name">{{ validatedTuner.name }}</div>
          <div class="tuner-option-check"><i class="pi pi-check-circle"></i></div>
        </div>
      </div>

      <div class="tuner-step-actions">
        <button class="confirm-cancel-btn" (click)="cancelTunerStep()">
          {{ 'proModal.tuner.cancelBtn' | transloco }}
        </button>
        <button class="confirm-cancel-btn" (click)="skipTunerStep()">
          {{ 'proModal.tuner.skipBtn' | transloco }}
        </button>
        <button class="confirm-ok-btn"
                [disabled]="tunerMode === 'list' ? !selectedTunerId : !validatedTuner"
                (click)="confirmTunerStep()">
          <i class="pi pi-check"></i>
          {{ 'proModal.tuner.confirmBtn' | transloco }}
        </button>
      </div>
    </div>

    <!-- Tela de confirmação de upgrade -->
    <div *ngIf="showConfirm && !showTunerStep && !tunerStepLoading" class="upgrade-confirm">
      <i class="pi pi-shield confirm-icon"></i>
      <h3 class="confirm-title">{{ (isPendingDowngrade() ? 'proModal.confirm.titleDowngrade' : 'proModal.confirm.title') | transloco }}</h3>
      <p class="confirm-desc">
        {{ (isPendingDowngrade() ? 'proModal.confirm.descBeforeDowngrade' : 'proModal.confirm.descBefore') | transloco }}
        <strong>{{ getPendingPlanName() }}</strong>
        {{ (isPendingDowngrade() ? 'proModal.confirm.descAfterDowngrade' : 'proModal.confirm.descAfter') | transloco }}
      </p>
      <div class="confirm-price-summary">
        <div class="confirm-price-row">
          <span class="confirm-price-label">{{ 'proModal.confirm.currentPlanLabel' | transloco }}</span>
          <span class="confirm-price-value">{{ getCurrentPlanPrice() }}</span>
        </div>
        <div class="confirm-price-row">
          <span class="confirm-price-label">{{ 'proModal.confirm.newPlanLabel' | transloco }}</span>
          <span class="confirm-price-value confirm-price-new">{{ getPendingPlanPrice() }}</span>
        </div>
        <ng-container *ngIf="!isPendingDowngrade()">
          <div class="confirm-price-divider"></div>
          <div class="confirm-price-row">
            <span class="confirm-price-label">{{ 'proModal.confirm.diffLabel' | transloco }}</span>
            <span class="confirm-price-value" [class.confirm-price-positive]="isPriceDiffPositive()" [class.confirm-price-negative]="!isPriceDiffPositive()">{{ getPriceDiff() }}</span>
          </div>
          <p class="confirm-proration-note" *ngIf="isPriceDiffPositive()">
            <i class="pi pi-info-circle"></i>
            {{ 'proModal.confirm.prorationNote' | transloco }}
          </p>
        </ng-container>
        <p class="confirm-proration-note" *ngIf="isPendingDowngrade()">
          <i class="pi pi-info-circle"></i>
          {{ 'proModal.confirm.downgradeNote' | transloco }}
        </p>
      </div>

      <p class="confirm-hint">
        <i class="pi pi-info-circle"></i>
        {{ 'proModal.confirm.hint' | transloco }}
      </p>
      <button class="confirm-portal-btn" [disabled]="portalLoading" (click)="openPortalFromModal()">
        <i class="pi pi-external-link"></i>
        {{ (portalLoading ? 'proModal.loading' : 'proModal.confirm.manageBtn') | transloco }}
      </button>
      <div class="confirm-actions">
        <button class="confirm-cancel-btn" [disabled]="checkoutLoading" (click)="cancelConfirm()">
          {{ 'proModal.confirm.cancelBtn' | transloco }}
        </button>
        <button class="confirm-ok-btn" [disabled]="checkoutLoading" (click)="confirmUpgrade()">
          <i class="pi pi-check"></i>
          {{ (checkoutLoading ? 'proModal.processing' : (isPendingDowngrade() ? 'proModal.confirm.confirmBtnDowngrade' : 'proModal.confirm.confirmBtn')) | transloco }}
        </button>
      </div>
      <div *ngIf="checkoutError" class="checkout-error">
        <i class="pi pi-exclamation-circle"></i> {{ checkoutError }}
      </div>
    </div>

    <!-- Tela de sucesso: mesma estrutura para upgrade imediato e downgrade agendado, só o
         texto muda (downgradeScheduled é setado no branch response.scheduled do checkout). -->
    <div *ngIf="upgradeSuccess && !showTunerStep && !tunerStepLoading" class="upgrade-success">
      <i class="pi pi-check-circle success-icon"></i>
      <h3 class="success-title">{{ (downgradeScheduled ? 'proModal.success.downgradeTitle' : 'proModal.success.title') | transloco }}</h3>
      <p class="success-desc">{{ (downgradeScheduled ? 'proModal.success.downgradeDesc' : 'proModal.success.desc') | transloco }}</p>
      <p class="success-desc" *ngIf="downgradeScheduled && downgradeEffectiveAt">
        {{ 'proModal.success.downgradeEffectiveAtLabel' | transloco }}
        <strong>{{ downgradeEffectiveAt | date:'dd/MM/yyyy' }}</strong>
      </p>
      <button class="confirm-ok-btn" (click)="close()">{{ 'proModal.success.closeBtn' | transloco }}</button>
    </div>

    <!-- Planos: duas telas no mesmo modal (cartões e matriz), no padrão que
         showConfirm/upgradeSuccess já usam. -->
    <ng-container *ngIf="!showConfirm && !upgradeSuccess && !showTunerStep && !tunerStepLoading">
      <p *ngIf="featureName" class="modal-subtitle">
        <strong>{{ featureName }}</strong> {{ 'proModal.subtitleSuffix' | transloco }}
      </p>

      <div *ngIf="loading" class="loading-wrapper">
        <p-progressSpinner styleClass="plan-spinner" strokeWidth="4" />
      </div>

      <ng-container *ngIf="!loading && orderedPlans.length > 0">

        <!-- Barra de topo: identidade da tela à esquerda, controles à direita. -->
        <div class="plans-bar">
          <div class="plans-bar-title">
            <h3>{{ 'proModal.title' | transloco }}</h3>
            <span>{{ 'proModal.subtitle' | transloco }}</span>
          </div>

          <div class="plans-bar-controls">
            <!-- Só diferenças: esconde as linhas idênticas em todos os planos, que
                 não carregam informação de comparação. Só é possível porque a ordem
                 é canônica — sem ela não há como saber que uma linha é constante. -->
            <button type="button" class="diff-switch"
                    [class.is-on]="onlyDifferences"
                    [attr.aria-pressed]="onlyDifferences"
                    (click)="toggleOnlyDifferences()">
              <span class="diff-switch-track"></span>
              {{ 'proModal.compare.onlyDiff' | transloco }}
            </button>

            <div class="billing-toggle">
              <button class="toggle-btn" [class.active]="!billingAnnual" (click)="toggleBilling(false)">{{ 'proModal.billing.monthly' | transloco }}</button>
              <button class="toggle-btn" [class.active]="billingAnnual" (click)="toggleBilling(true)">{{ 'proModal.billing.annual' | transloco }}</button>
            </div>
          </div>
        </div>

        <!-- Largo: matriz completa, um rótulo por recurso e uma coluna por plano. -->
        <div class="compare-scroll" *ngIf="!isNarrow">
          <table class="compare">
            <!-- table-layout fixo: em `auto` o navegador dimensiona cada coluna
                 pelo conteúdo, e os rótulos dos botões desbalanceiam as larguras. -->
            <colgroup>
              <col class="compare-col-label" />
              <col *ngFor="let plan of orderedPlans" />
            </colgroup>

            <thead>
              <tr>
                <td></td>
                <th *ngFor="let plan of orderedPlans" scope="col"
                    [class.is-current]="isCurrentPlan(plan) && !isManualCurrentPlan(plan)">
                  <div class="compare-plan">
                    <!-- Marca o plano atual inclusive quando é cortesia: sem isso, quem
                         está num plano manual não via indicação nenhuma na matriz. -->
                    <span class="compare-tag"
                          [class.manual-badge]="isManualCurrentPlan(plan)"
                          [class.is-hidden]="!isCurrentPlan(plan)">
                      {{ (isManualCurrentPlan(plan)
                            ? 'proModal.planCard.manualBadge'
                            : 'proModal.planCard.currentBadge') | transloco }}
                    </span>
                    <span class="plan-name">{{ plan.name }}</span>
                    <ng-container *ngTemplateOutlet="planPrice; context: { $implicit: plan }"></ng-container>
                    <ng-container *ngTemplateOutlet="planAction; context: { $implicit: plan }"></ng-container>
                  </div>
                </th>
              </tr>
            </thead>

            <tbody>
              <tr class="compare-group">
                <td [attr.colspan]="orderedPlans.length + 1">{{ 'proModal.compare.capacityGroup' | transloco }}</td>
              </tr>
              <tr *ngFor="let row of visibleCapacityRows" [class.is-same]="row.same">
                <th scope="row">{{ row.labelKey ? (row.labelKey | transloco) : row.label }}</th>
                <td *ngFor="let cell of row.cells; let i = index"
                    [class.is-current]="isCurrentPlan(orderedPlans[i]) && !isManualCurrentPlan(orderedPlans[i])">
                  <span *ngIf="cell.kind === 'value'">{{ cell.text }}</span>
                  <i *ngIf="cell.kind === 'yes'" class="pi pi-check compare-yes"></i>
                  <span *ngIf="cell.kind === 'no'" class="compare-no">&ndash;</span>
                </td>
              </tr>
            </tbody>

            <tbody *ngIf="visibleFeatureRows.length > 0">
              <tr class="compare-group">
                <td [attr.colspan]="orderedPlans.length + 1">{{ 'proModal.compare.featuresGroup' | transloco }}</td>
              </tr>
              <tr *ngFor="let row of visibleFeatureRows" [class.is-same]="row.same">
                <th scope="row">{{ row.labelKey ? (row.labelKey | transloco) : row.label }}</th>
                <td *ngFor="let cell of row.cells; let i = index"
                    [class.is-current]="isCurrentPlan(orderedPlans[i]) && !isManualCurrentPlan(orderedPlans[i])">
                  <span *ngIf="cell.kind === 'value'">{{ cell.text }}</span>
                  <i *ngIf="cell.kind === 'yes'" class="pi pi-check compare-yes"></i>
                  <span *ngIf="cell.kind === 'no'" class="compare-no">&ndash;</span>
                </td>
              </tr>
            </tbody>
          </table>

        </div>

        <!-- Estreito: a matriz de quatro colunas não cabe, então mostra uma coluna
             de valores por vez. As linhas e a ordem são exatamente as mesmas, então
             trocar de plano muda o número no mesmo lugar da tela — comparar vira um
             toque, em vez de rolar na horizontal e perder o rótulo de vista. -->
        <div class="compare-narrow" *ngIf="isNarrow">
          <div class="cn-switch" role="tablist">
            <button *ngFor="let plan of orderedPlans; let i = index"
                    type="button"
                    role="tab"
                    class="cn-switch__tab"
                    [class.is-active]="i === narrowPlanIndex"
                    [attr.aria-selected]="i === narrowPlanIndex"
                    (click)="narrowPlanIndex = i">
              {{ plan.name }}
              <span class="cn-switch__dot" *ngIf="isCurrentPlan(plan)"></span>
            </button>
          </div>

          <div class="cn-head" *ngIf="orderedPlans[narrowPlanIndex] as plan">
            <span class="compare-tag"
                  [class.manual-badge]="isManualCurrentPlan(plan)"
                  *ngIf="isCurrentPlan(plan)">
              {{ (isManualCurrentPlan(plan)
                    ? 'proModal.planCard.manualBadge'
                    : 'proModal.planCard.currentBadge') | transloco }}
            </span>
            <ng-container *ngTemplateOutlet="planPrice; context: { $implicit: plan }"></ng-container>
            <ng-container *ngTemplateOutlet="planAction; context: { $implicit: plan }"></ng-container>
          </div>

          <div class="cn-rows">
            <p class="cn-group" *ngIf="visibleCapacityRows.length > 0">
              {{ 'proModal.compare.capacityGroup' | transloco }}
            </p>
            <div class="cn-row" *ngFor="let row of visibleCapacityRows" [class.is-same]="row.same">
              <span class="cn-row__label">{{ row.labelKey ? (row.labelKey | transloco) : row.label }}</span>
              <span class="cn-row__value">
                <span *ngIf="row.cells[narrowPlanIndex].kind === 'value'">{{ row.cells[narrowPlanIndex].text }}</span>
                <i *ngIf="row.cells[narrowPlanIndex].kind === 'yes'" class="pi pi-check compare-yes"></i>
                <span *ngIf="row.cells[narrowPlanIndex].kind === 'no'" class="compare-no">&ndash;</span>
              </span>
            </div>

            <p class="cn-group" *ngIf="visibleFeatureRows.length > 0">
              {{ 'proModal.compare.featuresGroup' | transloco }}
            </p>
            <div class="cn-row" *ngFor="let row of visibleFeatureRows" [class.is-same]="row.same">
              <span class="cn-row__label">{{ row.labelKey ? (row.labelKey | transloco) : row.label }}</span>
              <span class="cn-row__value">
                <span *ngIf="row.cells[narrowPlanIndex].kind === 'value'">{{ row.cells[narrowPlanIndex].text }}</span>
                <i *ngIf="row.cells[narrowPlanIndex].kind === 'yes'" class="pi pi-check compare-yes"></i>
                <span *ngIf="row.cells[narrowPlanIndex].kind === 'no'" class="compare-no">&ndash;</span>
              </span>
            </div>
          </div>
        </div>

        <p class="compare-hidden-note" *ngIf="onlyDifferences && hiddenRowCount > 0">
          {{ 'proModal.compare.hiddenNote' | transloco: { count: hiddenRowCount } }}
        </p>

        <!-- Preço e ação são idênticos nos dois layouts; ficam num template só
             pra não existirem em duas cópias que podem divergir. -->
        <ng-template #planPrice let-plan>
          <div class="plan-price">
            <span *ngIf="isFree(plan)" class="price-free">{{ 'proModal.planCard.free' | transloco }}</span>
            <span *ngIf="!isFree(plan) && isPriceUnavailable(plan)" class="price-amount">{{ 'proModal.planCard.onRequest' | transloco }}</span>
            <ng-container *ngIf="!isFree(plan) && !isPriceUnavailable(plan)">
              <span class="price-amount">{{ formatPrice(plan) }}</span>
              <span class="price-period">{{ (billingAnnual ? 'proModal.planCard.perYear' : 'proModal.planCard.perMonth') | transloco }}</span>
            </ng-container>
          </div>
        </ng-template>

        <ng-template #planAction let-plan>
          <div class="plan-action">
            <p-button
              *ngIf="!isCurrentPlan(plan) || isManualCurrentPlan(plan)"
              [label]="(isDowngrade(plan) ? 'proModal.planCard.downgradeBtn' : 'proModal.planCard.upgradeBtn') | transloco"
              [icon]="isDowngrade(plan) ? 'pi pi-arrow-down' : 'pi pi-arrow-right'"
              iconPos="right"
              [styleClass]="isDowngrade(plan) ? 'downgrade-btn' : 'upgrade-btn'"
              [loading]="checkoutLoading"
              [disabled]="checkoutLoading || isPriceUnavailable(plan)"
              (onClick)="goToSubscription(plan.planId)" />
            <p-button
              *ngIf="isCurrentPlan(plan) && !isManualCurrentPlan(plan)"
              [label]="'proModal.planCard.currentBtn' | transloco"
              icon="pi pi-check"
              severity="success"
              [disabled]="true"
              styleClass="current-btn" />
          </div>
        </ng-template>
      </ng-container>

      <div *ngIf="checkoutError" class="checkout-error">
        <i class="pi pi-exclamation-circle"></i> {{ checkoutError }}
      </div>
    </ng-container>
  </div>

  <!-- <ng-template pTemplate="footer">
    <div class="modal-footer">
      <p-button label="Fechar" severity="secondary" [outlined]="true" (onClick)="close()" />
    </div>
  </ng-template> -->
</p-dialog>

<!-- Passo de afiliados do downgrade: dialog própria, empilhada sobre a de planos —
     só existe enquanto downgradeAffiliatesPlanId estiver setado. -->
<app-downgrade-affiliates-modal
    *ngIf="downgradeAffiliatesPlanId"
    [tunerId]="resolvedTunerId!"
    [targetPlanId]="downgradeAffiliatesPlanId"
    (confirmed)="onDowngradeAffiliatesConfirmed()"
    (cancelled)="onDowngradeAffiliatesCancelled()" />
